import {GroupSelection, Selection, TreeviewSelection} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public GroupSelection: GroupSelection,
    public Selection: Selection,
    public TreeviewSelection: TreeviewSelection,
  ) {}
}